<!--
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-21 18:55:32
-->
<template>
  <section>
    <div class="role">
      <div class="roleRight" style="border-left: 0">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchPostList"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
          <el-select v-if="searchShow" v-model="search.timeStatus" clearable placeholder="请选择">
            <el-option label="未开启" value="0"></el-option>
            <el-option label="生效中" value="1"></el-option>
            <el-option label="已过期" value="2"></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="SearchPostList"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table v-loading="loading" 
          element-loading-text="等待接口数据返回中······"
          :data="tableData" size="medium" border>
            <el-table-column
                fixed
                label="序号"
                prop="postId"
                type="index"
                width="100"
            >
              <template slot-scope="scope">
                <span>{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" min-width="200" align="left">
            </el-table-column>
            <el-table-column prop="descr" label="说明" align="left" min-width="120">
            </el-table-column>
            <el-table-column prop="descr" label="有效状态" align="left" min-width="120">
              <template slot-scope="scope">
                <el-tag size="small" v-if="scope.row.timeStatus==0">未开启</el-tag>
                <el-tag size="small" v-if="scope.row.timeStatus==1">生效中</el-tag>
                <el-tag size="small" v-if="scope.row.timeStatus==2">已过期</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="dislike" label="有效期" width="320">
              <template slot-scope="scope">
                <span>{{ scope.row.startTime }} - {{ scope.row.expireTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ctime" label="创建时间" width="180">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="80">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :disabled="statusShow"
                    :inactive-value="0"
                    @change="handleSwitch(scope.row)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column width="260" v-if="editShow || deleteShow" fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button
                    v-if="editShow"
                    @click="handleClick('change', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button
                >
                <el-button
                    v-if="configShow"
                    @click="getConfigureInfo(scope.row)"
                    plain
                    size="small"
                >配置
                </el-button
                >
                <el-button
                    v-if="deleteShow"
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑导航"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="650px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >
          <el-form-item
              class="item"
              label="名称："
              prop="name"
          >
            <el-input
                clearable
                style="width: 472px"
                placeholder="请填写名称"
                v-model="params.name"
            ></el-input>
          </el-form-item>
          <el-form-item
              class="item"
              label="说明："
          >
            <el-input
                clearable
                style="width: 472px"
                :rows="4"
                type="textarea"
                placeholder="请填写说明"
                v-model="params.descr"
            ></el-input>
          </el-form-item>
          <el-form-item label="有效期：" prop="startTime" style="margin-bottom: 10px">
            <el-date-picker
                style="width:472px"
                v-model="birthdayDate"
                @change="handleDateChange(arguments)"
                type="datetimerange"
                start-placeholder="起始时间"
                end-placeholder="截止时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <span style="color: #ff0000">*同一时段，只能设置一个</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <!-- 导航配置 -->
    <el-dialog
        title="配置导航"
        :visible.sync="configureVisible"
        :close-on-click-modal="false"
        width="1000px"
        style="cursor: pointer"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <div class="box_chang_info">
          <div>名称：</div>
          <div>{{ configureInfo.name }}</div>
        </div>
        <div class="box_chang_info">
          <div>有效期：</div>
          <div>{{ configureInfo.startTime }}-{{ configureInfo.expireTime }}</div>
        </div>
        <div class="box_chang_info">
          <div></div>
          <el-button type="primary" @click="saveConfigure" plain size="mini">保存</el-button>
        </div>
        <div class="box_chang_info">
          <div>配置项：</div>
          <div class="tab_info" v-loading="loading" element-loading-text="等待接口数据返回中······" >
            <div class="tab_head_tou">
              <div class="serial one_line td_head">序号</div>
              <div class="one_line td_head">图标</div>
              <div class="name_box one_line td_head">名称</div>
              <div class="class_box one_line td_head">数据源</div>
              <div class="serial one_line td_head">排序</div>
              <div class="one_line td_head">导航</div>
              <div class="one_line td_head">分类</div>
              <div class="one_line td_head">默认</div>
              <div class="one_line last_line td_head">操作</div>
            </div>
            <div class="tab_head_tou content" v-for="(item,index) in configureList" :key="index">
              <div class="serial one_line td_head">{{ index + 1 }}</div>
              <div class="two_line td_head" @click="getPolicy(index)">
                <img v-if="item.icon" :src="item.icon">
              </div>
              <div class="name_box one_line td_head">
                <el-input placeholder="请输入" v-model="item.name" style="width:80%;"></el-input>
              </div>
              <div class="class_box one_line td_head">
                <el-select style="width: 80%;" v-model="item.contType" placeholder="请选择">
                  <el-option
                      label="自定义"
                      value="diy">
                  </el-option>
                  <el-option
                      label="分类"
                      value="cat">
                  </el-option>
                </el-select>
              </div>
              <div class="serial one_line td_head" style="">
                <el-input placeholder="请输入" v-model="item.seq" style="width: 80%;text-align: center"></el-input>
              </div>
              <div class="one_line td_head">
                <el-switch
                    v-model="item.nav"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </div>
              <div class="one_line td_head">
                <el-switch
                    v-model="item.cat"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </div>
              <div class="one_line td_head">
                <el-switch
                    v-model="item.def"
                    :active-value="1"
                    :inactive-value="0"
                    @change="changeSwitch(index)"
                >
                </el-switch>
              </div>
              <div class="one_line td_head last_line">
                <el-button type="primary" @click="dataSource(item.appCatItemId)" plain size="mini">数据</el-button>
                <el-button @click="delectList(index)" type="danger" plain size="mini">删除</el-button>
              </div>
            </div>
            <div @click="add_info_tab" class="tab_head_tou _tab_add">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 数据配置 -->
    <el-dialog
        title="数据源管理"
        :visible.sync="dataSourceVisible"
        :close-on-click-modal="false"
        width="1000px"
        style="cursor: pointer"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <div class="box_chang_info">
          <div>名称：</div>
          <div>{{ configureInfo.name }}</div>
        </div>
        <div class="box_chang_info">
          <div>有效期：</div>
          <div>{{ configureInfo.startTime }}-{{ configureInfo.expireTime }}</div>
        </div>
        <div class="content_box_items">
          <div class="item_chilid">
            <div>导航名称：</div>
            <div>{{ classconfigureInfo.name }}</div>
          </div>
          <div class="item_chilid">
            <div>数据源：</div>
            <div>{{ classconfigureInfo.contTypeName }}</div>
          </div>
        </div>
        <div class="public-table-data" style="margin-bottom: 20px" v-if="classconfigureInfo.contType=='diy'">
          <div></div>
          <el-button
              @click="onTestAll"
              size="mini"
              type="primary"
          >添加
          </el-button
          >
        </div>
        <div class="public-table-data" style="padding-bottom: 20px" v-if="classconfigureInfo.contType=='diy'">
          <el-table
              ref="multipleTable"
              size="medium"
              :data="testTableData"
              border
              style="width: 100%"
              v-loading="loading"
          >
            <el-table-column type="index" label="序号" width="80" align="center">
              <template slot-scope="scope">
                <span>{{scope.$index+1}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" align="center">
            </el-table-column>
            <el-table-column prop="examId" label="标识" width="150" align="center">
            </el-table-column>
            <el-table-column prop="descr" label="分类" width="150" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.categoryName1 }} - {{ scope.row.categoryName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <el-switch
                    :disabled="true"
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="primary"
                    @click="changRemove(scope.row.examInfoId)"
                    plain
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="public-table-data" style="padding-bottom: 20px" v-if="classconfigureInfo.contType=='cat'">
          <el-table
              ref="multipleTable"
              size="medium"
              :data="typeTableData"
              border
              default-expand-all
              style="width: 100%"
              row-key="categoryId"
              v-loading="loading"
              :tree-props="{ children: 'examCategoryVos' }"
          >
            <el-table-column prop="name" label="名称" align="left">
            </el-table-column>
            <el-table-column prop="descr" label="说明" width="150" align="center">
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <el-switch
                    :disabled="true"
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="scope" v-if="!scope.row.examCategoryVos">
                <el-button
                    v-if="scope.row.addShow"
                    size="mini"
                    type="warning"
                    @click="changAdd(scope.row)"
                    plain
                >添加
                </el-button
                >
                <el-button
                    v-if="!scope.row.addShow"
                    size="mini"
                    type="primary"
                    @click="changRemove(scope.row.categoryId)"
                    plain
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <!-- 测评题数据 -->
    <el-dialog
        title="数据源列表"
        :visible.sync="alldataSourceVisible"
        :close-on-click-modal="false"
        width="1000px"
        style="cursor: pointer"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <div class="public-table-data" style="margin-bottom: 20px" v-if="classconfigureInfo.contType=='diy'">
          <div></div>
          <el-button
              @click="saveTest"
              size="mini"
              type="primary"
          >添加
          </el-button
          >
        </div>
        <div class="public-table-data" style="padding-bottom: 20px" v-if="classconfigureInfo.contType=='diy'">
          <el-table
              ref="multipleTableTest"
              size="medium"
              :data="allTestTableData"
              border
              style="width: 100%"
              v-loading="loading"
              @selection-change="handleTarotSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" label="序号" width="80" align="center">
            </el-table-column>
            <el-table-column prop="name" label="名称" align="center">
            </el-table-column>
            <el-table-column prop="examId" label="标识" width="150" align="center">
            </el-table-column>
            <el-table-column prop="descr" label="分类" width="150" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.categoryName1 }} - {{ scope.row.categoryName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <el-switch
                    :disabled="true"
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="public-table-data" style="padding-bottom: 20px" v-else>
          <el-table
              ref="multipleTable"
              size="medium"
              :data="typeTableData"
              border
              default-expand-all
              style="width: 100%"
              row-key="categoryId"
              v-loading="loading"
              :tree-props="{ children: 'examCategoryVos' }"
          >
            <el-table-column prop="name" label="名称" align="center">
            </el-table-column>
            <el-table-column prop="descr" label="说明" width="150" align="center">
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <el-switch
                    :disabled="true"
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="scope" v-if="!scope.row.examCategoryVos">
                <el-button
                    v-if="scope.row.addShow"
                    size="mini"
                    type="warning"
                    @click="changAdd(scope.row)"
                    plain
                >添加
                </el-button
                >
                <el-button
                    v-if="!scope.row.addShow"
                    size="mini"
                    type="primary"
                    @click="changRemove(scope.row)"
                    plain
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <input
        type="file"
        ref="file"
        style="opacity: 0"
        @change="getFile"
        accept="image/png,image/jpg"
    />
  </section>
</template>
<script>
import {PAGE_SIZE} from "@/config";
import richText from "../../components/richText";
import {ossUpload} from "@utils/filters/upload";

export default {
  components: {
    richText
  },
  data() {
    return {
      flag: false,
      PAGE_SIZE,
      loading: false,
      listParams: {
        tree: true,
        paging: false,
      },
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      search: {},
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {},
      rules: {
        name: [
          {required: true, message: "请填写名称", trigger: "change"},
        ],
        startTime: [
          {required: true, message: "请选择有效期", trigger: "change"},
        ],
      }, //表单验证提示
      tableData: [], //列表
      birthdayDate: [],
      srcList: [],
      configureVisible: false,
      configureList: [],
      changImgIndex: '',
      configureInfo: {},

      classificationDataSource: [],
      classconfigureInfo: {},
      dataSourceVisible: false,
      typeTableData: [],
      dataIds: [],
      testTableData: [],
      allTestTableData: [],
      alldataSourceVisible: false,
      allIds:[],


      searchShow: false,
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      configShow: false
    };
  },
  async created() {
    this.getRoleListTree();
    await this.getPermissionButtonList()
    // this.getConfigureList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.srcList = []
        this.flag = false
        this.isMoer = true
        this.birthdayDate = []
      }
    },
    search: {
      handler(val) {
      },
      deep: true,
    },
  },
  methods: {
    handleTarotSelectionChange(val) {
      this.allIds = val
    },

    async saveTest(){
      if(this.allIds.length){
        let arr = []
        this.allIds.map(item=>{
          arr.push(item.examInfoId)
        })
        this.loading = true;
        let passData = {
          appCatItemId: this.classconfigureInfo.appCatItemId,
          bizIds: arr
        }
        const {data: resData} = await this.$post('/app/cat/biz/ids', passData);
        this.loading = false;
        if (resData.result != 200) return;
        this.$message.success('添加成功')
        this.getDataIds()
        this.alldataSourceVisible = false;
      }else {
        this.$message.error('请选择需要添加的内容')
      }
    },


    async queryTestTableData() {
      let arr = []
      this.loading = true;
      const {data: resData} = await this.$get("/exam/list?styleType=cpzy&paging=false");
      this.loading = false;
      if (resData.result != 200) return;
      resData.data.map(item => {
        if(this.dataIds.length){
          for (let i = 0; i < this.dataIds.length; i++) {
            if (item.examInfoId == this.dataIds[i]) {
              item.checkboxStatus = 1
              arr.push(item)
              break
            }
          }
        }
      })
      this.testTableData = arr;
      this.allTestTableData = resData.data
      this.dataSourceVisible = true
    },

    async onTestAll() {
      this.loading = true;
      const {data: resData} = await this.$get("/exam/list?styleType=cpzy&paging=false&exExamInfoIds=" + this.dataIds);
      this.loading = false;
      if (resData.result != 200) return;
      this.allTestTableData = resData.data
      this.alldataSourceVisible = true
    },


    //遍历分类下的树及树的数据
    async queryTableData() {
      this.loading = true;
      const {data: resData} = await this.$get("/exam/category/list", {
        params: this.listParams,
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data == undefined) {
        this.typeTableData = [];
        return
      }
      resData.data.map(item => {
        if (item.examCategoryVos) {
          item.examCategoryVos.map(items => {
            if(this.dataIds.length){
              for (let i = 0; i < this.dataIds.length; i++) {
                if (items.categoryId == this.dataIds[i]) {
                  items.addShow = false
                  break
                } else {
                  items.addShow = true
                }
              }
            }else {
              items.addShow = true
            }
          })
        }
      })
      this.typeTableData = resData.data
      this.dataSourceVisible = true
    },

    //分类下的新增
    async changAdd(e) {
      this.loading = true;
      let passData = {
        appCatItemId: this.classconfigureInfo.appCatItemId,
        bizIds: [e.categoryId]
      }
      const {data: resData} = await this.$post('/app/cat/biz/ids', passData);
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success('添加成功')
      this.getDataIds()
    },
    //分类下的删除
    async changRemove(e) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/app/cat/biz/id/${this.classconfigureInfo.appCatItemId}/${[e]}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getDataIds()
        this.$message.success("删除成功!");
      });
    },

    async getDataIds() {
      this.loading = true;
      const {data: resData} = await this.$get("/app/cat/biz/ids?appCatItemId=" + this.classconfigureInfo.appCatItemId);
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
         this.dataIds = resData.data
      }else {
        this.dataIds = []
      }
      if (this.classconfigureInfo.contType == 'diy') {
        this.queryTestTableData()
      } else {
        this.queryTableData()
      }
    },
    async dataSource(e) {
      this.loading = true;
      const {data: resData} = await this.$get('/app/cat/item/info?appCatItemId=' + e);
      this.loading = false;
      this.classconfigureInfo = resData.data;
      this.getDataIds()
    },

    add_info_tab() {
      let obj = {
        icon: '',
        name: '',
        contType: 'diy',
        seq: 1,
        nav: 0,
        cat: 1,
        def: 0
      }
      this.configureList.push(obj)
    },

    async getConfigureInfo(row) {
      this.loading = true;
      const {data: resData} = await this.$get('/app/cat/info/' + row.appCatInfoId);
      this.loading = false;
      this.configureInfo = resData.data;
      this.getConfigureList()
    },

    async getConfigureList() {
      this.loading = true;
      const {data: resData} = await this.$get('/app/cat/item/list?appCatInfoId=' + this.configureInfo.appCatInfoId);
      this.loading = false;
      this.configureList = resData.data;
      this.configureVisible = true
    },

    delectList(e) {
      let appCatItemId = this.configureList[e].appCatItemId
      if (appCatItemId) {
        this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
          type: "warning",
        }).then(async () => {
          const {data: resData} = await this.$delete(
              `/app/cat/item/${appCatItemId}`,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.getConfigureList();
          this.$message.success("删除成功!");
        });
      } else {
        this.configureList.splice(e, 1)
      }
    },

    changeSwitch(indexs) {
      let arr = this.configureList
      arr.map((item, index) => {
        if (index != indexs) {
          item.def = 0
        }
      })
    },


    async saveConfigure() {
      this.loading = true;
      this.configureList.map(item => {
        item.seq = Number(item.seq)
      })
      let passData = {
        appCatInfoId: this.configureInfo.appCatInfoId,
        catItems: this.configureList
      }
      const {data: resData} = await this.$post('/app/cat/item/info', passData);
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success('保存成功')
      this.getConfigureList()
    },


    getPolicy(e) {
      if (!this.configureList[e].icon) {
        this.configureList[e].icon = ''
      }
      this.changImgIndex = e
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },


    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.srcList = addRoutes;
      this.configureList[this.changImgIndex].icon = JSON.parse(JSON.stringify(this.srcList[0]))
      this.configureList = JSON.parse(JSON.stringify(this.configureList))
    },

    //switch状态改变 --接口 修改管理员状态
    handleSwitch(row) {
      this.$put(`/app/cat/info/status/${row.appCatInfoId}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },
    handleDateChange(args) {
      if (args[0]) {
        this.params.startTime = this.changFormDate(args[0][0]);
        this.params.expireTime = this.changFormDate(args[0][1]);
      } else {
        this.params.startTime = "";
        this.params.expireTime = "";
      }
    },

    changFormDate(e) {
      let date = new Date(e)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let Hour = date.getHours()
      let Minute = date.getMinutes()
      let Second = date.getSeconds()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      if (Hour < 10) {
        Hour = '0' + Hour
      }
      if (Minute < 10) {
        Minute = '0' + Minute
      }
      if (Second < 10) {
        Second = '0' + Second
      }
      let timeStr = year + '-' + month + '-' + day + ' ' + Hour + ':' + Minute + ':' + Second

      return timeStr
    },


    //权限处理
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'app:nav:query') {
            this.searchShow = true
          }
          if (item.code == 'app:nav:add') {
            this.addShow = true
          }
          if (item.code == "app:nav:delete") {
            this.deleteShow = true
          }
          if (item.code == "app:nav:edit") {
            this.editShow = true
          }
          if (item.code == "app:nav:status") {
            this.statusShow = false
          }
          if (item.code == "app:nav:config") {
            this.configShow = true
          }
        })
      }
    },
    //筛选
    SearchPostList() {
      this.page.pageNo = 1
      this.getRoleListTree()
    },
    /**
     *  获取列表
     */
    async getRoleListTree(data, checked) {
      let http = `/app/cat/info/list`;
      this.loading = true;
      const {data: resData} = await this.$get(http, {
        params: {...this.search, ...this.page},
      });
      this.loading = false;
      this.tableData = resData.data;
      this.page.count = resData.page.count;
    },
    // 弹窗
    async handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "change") {
        this.loading = true;
        const {data: resData} = await this.$get('/app/cat/info/' + row.appCatInfoId);
        this.loading = false;
        // //修改  change
        this.params = resData.data;
        this.birthdayDate = [
          [resData.data.startTime],
          [resData.data.expireTime],
        ];
        this.dialogVisible = true;
        this.flag = true
      } else {
        //添加
        this.params = {};
        this.flag = true
        this.dialogVisible = true;
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        let passData = this.params;
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addNext") {
            const {data: resData} = await this.$post("/app/cat/info", passData, {
              headers: {
                isLoading: true,
              },
            });
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.params = {};
            this.birthdayDate = []
            this.flag = false
            this.$message.success("添加成功!");
          } else if (this.clickType == "change") {
            //修改岗位
            const {data: resData} = await this.$put(
                "/app/cat/info",
                passData,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.params = {};
            this.birthdayDate = []
            this.flag = false
            this.$message.success("修改成功!");
          }
        });
      });
    },
    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/app/cat/info/${row.appCatInfoId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getRoleListTree();
        this.$message.success("删除成功!");
      });
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getRoleListTree();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getRoleListTree();
    },
  },
};
</script>

<style lang="scss" scoped>
.clear_icon_items {
  color: #F56C6C;
  position: absolute;
  left: -64px;
  top: 0;
}

.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Left {
    width: auto;
    padding-right: 15px;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 20px;
    }
  }

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    border-left: 1px solid #ccc;
    padding-left: 15px;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

.box_chang_info {
  display: flex;
  margin-bottom: 20px;
  font-size: 14px;

  .tab_info {
    border: 1px solid rgba(0,0,0,0.3);
    border-bottom: 0;
    background: #ffffff;

    .tab_head_tou {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(0,0,0,0.3);

      .td_head {
        text-align: center;
        height: 44px;
        line-height: 44px;
        border-right: 1px solid rgba(0,0,0,0.3);

        img {
          width: 80%;
          height: 80%;
          object-fit: contain;
        }
      }

      .one_line {
        width: 80px;
      }

      .class_box {
        width: 120px;
      }

      .serial {
        width: 60px;
      }

      .name_box {
        width: 160px;
      }

      .two_line {
        width: 280px;
      }

      .last_line {
        border-right: 0;
        width: 160px;
      }


    }

    .content {
      .two_line {
        width: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    ._tab_add {
      height: 44px;
      font-size: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #959595;
    }
  }
}

.box_chang_info > div:nth-child(1) {
  width: 80px;
  text-align: right;
}

.content_box_items {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .item_chilid {
    width: 200px;
    display: flex;
    align-items: center;
  }

  .item_chilid > div:nth-child(1) {
    width: 80px;
    text-align: right;
  }
}

</style>
